export default "__VITE_ASSET__B8F2HJpl__"